import ReactSelect from 'react-select';

import styled from 'styled-components';

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 2rem 0rem;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
  }

  .pagination {
    display: flex;

    li {
      user-select: none;

      a {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
      }

      margin: 1rem;
      position: relative;
      overflow: hidden;
      cursor: pointer;
      height: 35px;
      width: 35px;
      border: 1px solid #eceeef;
      color: #979797;
      display: flex;
      margin: 0px 5px;
      border-radius: 5px;
      justify-content: center;
      align-items: center;
      transition: 0.3s ease-in-out;
      background: transparent;

      svg {
        width: 18px;
      }

      :not(:disabled):hover {
        color: ${props => props.theme.secondaryColor};
        border: 1px solid ${props => props.theme.secondaryColor};
      }

      &.disabled {
        cursor: not-allowed;
        opacity: 0.5;

        :hover {
          background: transparent;
          color: #979797;
          border: 1px solid #eceeef;
        }
      }

      &.active {
        color: ${props => props.theme.secondaryColor};
        border: 1px solid ${props => props.theme.secondaryColor};
      }
    }
  }
`;

export const PageSize = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    margin-bottom: 2rem;
  }
`;

export const ReactSelectCustom = styled(ReactSelect)`
  margin-left: 1rem;
  width: 80px;

  .react-select__option {
    background: #fff;
  }

  .react-select__value-container {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    .react-select__single-value {
      color: ${props => props.theme.textColor};
    }
  }

  .react-select__control {
    &:hover,
    &:active,
    &:visited,
    &:focus-visible,
    &:focus-within,
    &:focus {
      border: 1px solid ${props => props.theme.secondaryColor};
      box-shadow: none;
    }
  }

  .react-select__option {
    background: #fff;
    color: ${props => props.theme.textColor};
    display: flex;
    align-items: center;

    &:hover {
      background: ${props => props.theme.primaryColor};
      color: #fff;
      fill: #fff;
    }

    &:hover svg {
      color: #fff;
      fill: #fff;
    }
  }

  .react-select__single-value {
    display: flex;
    align-items: center;
  }
`;
